import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { IAddon } from "../../models/Addon";
import { AddonService } from "../../services/addon.service";

export const useGetAllAddonsQuery = () => {
  return useQuery<IAddon[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_ALL_ADDONS],
    queryFn: () => AddonService.getAllAddons().then((res) => res.data),
  });
};
